import dispatchManage from "@/components/dispatchManage/index.vue";
import currentDispatch from "@/components/dispatchManage/currentDispatch.vue";
import historyDispatch from "@/components/dispatchManage/historyDispatch.vue";

export default {
  router: {
    path: "/dispatchManage",
    name: "dispatchManage",
    component: dispatchManage,
    props: true,
    children: [
      {
        path: "currentDispatch",
        name: "currentDispatch",
        component: currentDispatch,
        props: true
      }, {
        path: 'historyDispatch',
        name: 'historyDispatch',
        component: historyDispatch,
        props: true
      },
    ]
  },
}